import React from 'react';
import classNames from 'classnames';

import { Page, LayoutSingleColumn } from '../../components';
import TopbarContainer from '../TopbarContainer/TopbarContainer';
import FooterContainer from '../FooterContainer/FooterContainer';
import buttonStyles from '../../components/Button/Button.module.css';
import css from './AccompagnementProjetDomotiquePage.module.css';

// Visuels temporaires : remplacez par vos images (jpg, webp, png) en gardant les imports ci-dessous.
import imgBesoins from './images/besoins.svg';
import imgTechnologie from './images/technologie.svg';
import imgProduits from './images/produits.svg';
import imgInstallation from './images/installation.svg';

const CALENDAR_BOOKING_URL = 'https://calendar.app.google/shsPuuDMcMN3Cub89';

const PAGE_TITLE = 'Accompagnement Projet Maison Connectée & Domotique | Neokasa';
const PAGE_DESCRIPTION =
  'Vous avez un projet de construction, de rénovation, ou vous souhaitez simplement moderniser votre intérieur ? Évitons ensemble les erreurs classiques et les produits incompatibles.';

const SERVICE_POINTS = [
  {
    image: imgBesoins,
    imageAlt: 'Illustration : analyse des besoins domotiques',
    title: 'Analyser vos besoins',
    text: 'Sécurité, confort thermique, éclairage intelligent ou divertissement.',
  },
  {
    image: imgTechnologie,
    imageAlt: 'Illustration : choix des protocoles et écosystèmes',
    title: 'Aide au choix technologique',
    text: 'Comparatif des protocoles (Zigbee, Matter, Thread…) et des écosystèmes (Apple Home, Google Home, Home Assistant, etc.).',
  },
  {
    image: imgProduits,
    imageAlt: 'Illustration : sélection de produits connectés',
    title: 'Sélection de produits',
    text: 'Recommandations de matériel fiable et adapté à votre budget (interrupteurs, caméras, thermostats, motorisations).',
  },
  {
    image: imgInstallation,
    imageAlt: 'Illustration : installation et configuration',
    title: "Conseils d'installation",
    text: 'Validation de la faisabilité technique et astuces pour une configuration stable.',
  },
];

const AccompagnementProjetDomotiquePage = () => {
  return (
    <Page title={PAGE_TITLE} description={PAGE_DESCRIPTION} scrollingDisabled={false}>
      <LayoutSingleColumn topbar={<TopbarContainer />} footer={<FooterContainer />}>
        <div className={css.root}>
          <div className={css.container}>
            <h1 className={css.title}>Accompagnement Projet Maison Connectée &amp; Domotique</h1>
            <p className={css.lead}>{PAGE_DESCRIPTION}</p>
            <p className={css.sessionNote}>
              <strong>Rendez-vous de 30 minutes</strong> en visioconférence avec un expert Neokasa.
              Lors de cet échange, nous mettons notre expertise à votre service pour :
            </p>

            <h2 className={css.benefitsSectionTitle}>Au programme de l&apos;échange</h2>
            <ul className={css.benefitsGrid}>
              {SERVICE_POINTS.map(point => (
                <li key={point.title} className={css.benefitCard}>
                  <div className={css.benefitImageWrap}>
                    <img
                      className={css.benefitImage}
                      src={point.image}
                      alt={point.imageAlt}
                      loading="lazy"
                      decoding="async"
                    />
                  </div>
                  <div className={css.benefitBody}>
                    <h3 className={css.benefitTitle}>{point.title}</h3>
                    <p className={css.benefitText}>{point.text}</p>
                  </div>
                </li>
              ))}
            </ul>

            <div className={css.sectionCard}>
              <h2 className={css.prepHeading}>Comment se préparer ?</h2>
              <p className={css.prepText}>
                Pour maximiser notre temps, n&apos;hésitez pas à préparer une liste rapide de vos
                équipements actuels ou les plans de votre logement si nécessaire.
              </p>
            </div>

            <div className={css.ctaWrap}>
              <a
                className={classNames(
                  buttonStyles.primaryButtonRoot,
                  buttonStyles.primaryButton,
                  css.ctaLink
                )}
                href={CALENDAR_BOOKING_URL}
                target="_blank"
                rel="noopener noreferrer"
              >
                Prendre rendez-vous (30 min)
              </a>
            </div>
          </div>
        </div>
      </LayoutSingleColumn>
    </Page>
  );
};

export default AccompagnementProjetDomotiquePage;
